<template>
  <div class="new-union" v-if="unionHead">
    <div class="nav-bar" :style="{'background-color':unionHead.unionConfigurationDto.colour}">
      <div class="nav-bar__wrapper nf-flex">
        <HomeLink :unionHead="unionHead"></HomeLink>
        <CitySelector class="right"></CitySelector>
        <Message v-if="loginData.userStatus == 2" class="nf-ml-40"></Message>
        <Language class="nf-ml-40"></Language>
        <User v-if="loginData.userStatus == 2" class="nf-ml-40" :unionHead="unionHead" :loginData="loginData"></User>
      </div>
    </div>
    <Notice v-if="isShowNotice">{{currentNoticeContent}}</Notice>
    <div
      class="header-body"
      :style="`background-image:url(${unionHead.unionConfigurationDto.bgImage}); background-repeat: no-repeat; background-size: cover`"
    >
      <img
        class="logo"
        :src="unionHead.mallUnionConfigDto.logo"
        alt
      />
      <div class="channels">
        <Channels v-if="unionMenu && unionMenu.length > 0" :menu="unionMenu" :isActive="isMenuActive" :color="unionHead.unionConfigurationDto.colour" />
      </div>
      <img class="contact" :src="unionHead.unionConfigurationDto.pcPhoneUrl" alt />
      <SearchBox v-if="unionHead.mallUnionConfigDto.isShowSearch" @search="onSumbit"></SearchBox>
    </div>
    <!-- <Menu :menu="unionMenu" v-if="unionMenu.length" :isActive="isMenuActive">
      <template v-slot:default="{value}">
        <a
          :href="value.url"
          target="_self"
          :style="value.code === 'health' ? `color: ${colour}` : ''"
        >
          <span v-if="lang !== 'en-US'">{{ value.name }}</span>
          <span v-else>{{ value.enName }}</span>
        </a>
      </template>
      <template slot="expend">{{ lang !== "en-US" ? TLang('全部频道', 'my') : "ALL" }}</template>
    </Menu> -->
  </div>
</template>

<script>
import CitySelector from "./CitySelector";
import HomeLink from "./HomeLink";
import Message from "./Message";
import User from "./User";
import Menu from "./Menu";
import Channels from "./Channels";
import Notice from "./Notice";
import SearchBox from "./SearchBox";
import Language from "./Language.vue";
import Cookies from "js-cookie";
import { gioClickHandle as gioHandle, getQueryString, getCookie } from "../../../utils";

export default {
  name: "NewUnion2023",
  components: {
    HomeLink,
    Menu,
    Channels,
    User,
    Message,
    CitySelector,
    Notice,
    SearchBox,
    Language,
  },
  data() {
    return {
      unionHead: null,
      loginData: null,
      unionMenu: [],
      noticeData: null,
      noticeInit: {
        color: '#3d96e2',
        col1: 1,
        col2: 23,
      },
      lang: getCookie('df_lang') || 'zh-CN',
    };
  },
  computed: {
    colour() {
      const { colour } = this.unionHead.unionConfigurationDto;
      return colour ? colour : "#2c2d78";
    },
    hoverStyle() {
      const { colour } = this.unionHead.unionConfigurationDto;
      return {
        color: colour ? colour : '#247dff',
        fontWeight: 'bold',
      };
    },
    isShowNotice() {
      if(!this.noticeData) {
        return false;
      }
      if(!this.unionHead.mallUnionConfigDto) {
        return false;
      }
      const {openNotice,isShowUnionNotice} = this.unionHead.mallUnionConfigDto;
      return openNotice || isShowUnionNotice;
    },
    currentNoticeContent() {
      const { noticeContent } = this.noticeData;

      if (this.unionHead) {
        const { mallUnionConfigDto } = this.unionHead;

        if (mallUnionConfigDto) {
          const {
            openNotice,
            isShowUnionNotice,
            unionNoticeContent,
          } = mallUnionConfigDto;

          if (openNotice) {
            if (isShowUnionNotice) {
              return noticeContent + unionNoticeContent;
            } else {
              return noticeContent;
            }
          } else {
            if (isShowUnionNotice) {
              return unionNoticeContent;
            }
          }
        }
      }

      return noticeContent;
    },
  },
  created() {
    // 获取登录状态
    this.getLoginStatus();
    // 获取工会信息
    this.getFindByUnion();

    // 获取工会菜单
    this.getFindUsableList();

    // 获取公告内容
    this.getNoticeData();
  },
  methods: {
    isMenuActive(item) {
      let path = window.sessionStorage.getItem('currentChannel') || getCookie('phpUnionCurrentChannel');
      if (item.key === path) {
        return true;
      }
      return false;
    },
    getFindByUnion() {
      // this.apis.headerApi.getFindByUnion().then(res => {
      //   this.unionHead = res;
      // });
      const cityId = Cookies.get('address') && JSON.parse(Cookies.get('address')).cityId || getQueryString('city') || 145;
      this.apis.newBfdHeaderApi.getFindByUnion({city: cityId}).then(res => {
        this.unionHead = res.data;
      });
    },
    getLoginStatus() {
      // this.apis.headerApi.getLoginStatus().then(res => {
      //   sessionStorage.setItem('loginInfo', JSON.stringify(res));
      //   if (res.loginFlag) {
      //     this.loginData = res;
      //   } else {
      //     window.location.href = res.loginUrl;
      //   }
      // });
      this.apis.newBfdHeaderApi.getLoginStatus().then(res => {
        sessionStorage.setItem('loginInfo', JSON.stringify(res.data));
        if (res.data.userStatus == 2) {
          this.loginData = res.data;
        } else {
          window.location.href = res.data.pcLoginUri;
        }
      });
    },
    getFindUsableList() {
      // this.apis.headerApi.getFindUsableList().then(res => {
      //   this.unionMenu = res;
      // });
      this.apis.newBfdHeaderApi.getFindUsableList().then(res => {
        // console.log('新百福得接口数据', res.data);
        this.unionMenu = res.data;
      });
    },
    getNoticeData() {
      // this.apis.headerApi.getNotice().then(res => {
      //   this.noticeData = res;
      // });
      this.apis.newBfdHeaderApi.getNotice().then((res) => {
        // console.log('新百福得接口数据', res.data);
        this.noticeData = res.data;
      });
    },
    goGio(isCiUrl, value){
      let pathName = window.location.pathname;
      let channelName = "优选生活";
      if (pathName.indexOf("home") > -1) {
        channelName = "优选生活";
      } else if (pathName.indexOf("book") > -1) {
        channelName = "图书";
      } else if (pathName.indexOf("birthday") > -1) {
        channelName = "生日汇";
      } else if (getQueryString("productTypes")) {
        channelName = getQueryString("productTypes");
      }
      gioHandle("DF_elementClick", {
        df_channle: channelName,
        df_pagename: "搜索页",
        df_modulename: "搜索历史",
        df_elementname: "搜索历史词",
        df_searchKeyword: value,
        df_pageType: isCiUrl ? "词链" : ""
      });
    },
    async onSumbit(value) {
      const city = (Cookies.get('address') &&
              JSON.parse(Cookies.get('address') || '{}').cityId) ||
          '145';
      const res = await this.apis.headerApi.getSearchUrl({keyword: value, city});
      if (res && res.body && res.body.linkUrl) {
        this.goGio(true, value);
        window.location.href = res.body.linkUrl;
      } else {
        this.goGio(false, value);
        location.href = `${this.unionHead.mallUnionConfigDto.pcSearchUrl}${value}`;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-bar {
  line-height: 20px;
  padding-top: 4px;
  padding-bottom: 4px;
  min-width: 1200px;
  // &__left {
  //   float: left;
  //   width: 100%;
  //   height: 20px;
  // }
  &__wrapper {
    .wrapper();
  }
  &__user {
    height: 20px;
    text-align: right;
    > ul {
      display: inline-block;
    }
  }
  &__item {
    float: left;
    color: #fff;
    margin-left: 5px;
    > a {
      color: #fff;
    }
    &_en {
      &:before {
        content: "/";
        position: relative;
        top: -1px;
        margin-left: 1px;
        margin-right: 1px;
      }
    }
  }

}
.nav-bar {
  background-color: #2c2d78;
  padding: 14px 0px;
  line-height: 20px;
  &__wrapper {
    position: relative;
    .wrapper();
  }
}
.header-body {
  .wrapper();
  padding: 24px 0px;
  display: flex;
  .logo {
    height: 40px;
    margin-right: 25px;
  }
  .channels {
    margin-right: auto;
    margin-top: 7px;
  }
  .contact {
    height: 40px;
    margin-right: 24px;
  }
}
</style>
